<template>
  <div>
    <v-autocomplete
      id="solution-select"
      v-model="solucaoId"
      item-text="nome"
      item-value="solucaoId"
      :items="solutions"
      :label="`${isAT ? 'Iniciativas' : isGov ? 'Fases' : 'Solução'}`"
      placeholder="Solução"
      :clearable="!removeClearable"
      :multiple="multiple"
      :item-text="
        (item) =>
          `${item.municipioPropostaSolucoesExtrasId ? '(extra) ' : ''} ${
            item.nome
          }`
      "
      @change="$emit('changeSolution', solucaoId)"
      :return-object="returnObject"
    >
      <template v-slot:selection="{ item, index }">
        <span v-if="index < maxDisplay"
          >{{ diminuirValue(item.nome) }} &nbsp;</span
        >
        <span v-if="index === maxDisplay" class="grey--text caption"
          >(+{{ solucaoId.length - maxDisplay }} soluções)</span
        >
      </template>

      <template slot="no-data">
        Nenhuma {{ isAT ? "Iniciativa" : isGov ? "Fase" : "Solução" }} retornada
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { solutionAPI } from "@/modules/solution";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppSolutionCombobox",
  props: [
    "filter",
    "multiple",
    "filterSolutions",
    "solutionIds",
    "returnObject",
    "returnExtraTitle",
    "removeClearable",
  ],
  data() {
    return {
      solutions: [],
      solucaoId: null,
      maxDisplay: 1,
    };
  },
  methods: {
    loadSolutions() {
      solutionAPI.list({}).then((res) => {
        this.solutions = res.data;
      });
    },
    diminuirValue(item) {
      if (item && item.length > 15) {
        return item.substring(0, 15) + "...";
      }

      return item;
    },
  },
  computed: {
    ...mapGetters(["isAT", "isGov"]),
  },
  watch: {
    filterSolutions: {
      handler(val, oldVal) {
        if (val && val.length) {
          this.solutions = val;
        }
      },
      deep: true,
    },
    solutionIds: {
      handler(val) {
        console.log("🚀 ~ handler ~ val:", val);
        this.solucaoId = val;
        this.$forceUpdate();
      },
      deep: true,
    },
    filter: {
      handler(val, oldVal) {
        console.log("🚀 ~ handler ~ val:", val);
        this.solucaoId = val.solucaoId;
        if (val.solutions) this.solutions = val.solutions;
      },
      deep: true,
    },
  },
  mounted() {
    if (!this.filter.solutions) {
      this.loadSolutions();
    } else {
      this.solutions = this.filter.solutions;
    }
    this.solucaoId = this.solutionIds;
  },
};
</script>
